// SSO cookie half of the session-transfer helpers; the URL helpers are in @universal/lib/sessionTransferUrl.
import { getCookie, setCookie } from '@lib/cookies';

export const SSO_HINT_COOKIE = 'naf.sso';
export const SSO_HINT_DOMAIN = 'naf.no';

const SSO_HINT_VALUE = '1';
const SSO_HINT_DAYS = 1;

export const SESSION_GONE_ERRORS = ['login_required', 'consent_required'];

const canUseCookies = () => typeof window !== 'undefined' && typeof document !== 'undefined';

export const isSsoHintHost = (hostname: string): boolean =>
  hostname === SSO_HINT_DOMAIN || hostname.endsWith(`.${SSO_HINT_DOMAIN}`);

const hintDomain = () => (isSsoHintHost(window.location.hostname) ? SSO_HINT_DOMAIN : undefined);

const isSecureContext = () => window.location.protocol === 'https:';

// Auth0 iframe silent auth only sees the shared session on naf.no hosts. Off-domain
// (localhost) it always fails with login_required, which clears the local session.
export const canUseSsoSession = (): boolean => canUseCookies() && isSsoHintHost(window.location.hostname);

export const hasSsoHint = (): boolean => canUseCookies() && getCookie(SSO_HINT_COOKIE) === SSO_HINT_VALUE;

export const setSsoHint = (): void => {
  if (!canUseCookies()) return;
  setCookie(SSO_HINT_COOKIE, SSO_HINT_VALUE, SSO_HINT_DAYS, 'Lax', isSecureContext(), hintDomain());
};

export const clearSsoHint = (): void => {
  if (!canUseCookies()) return;
  setCookie(SSO_HINT_COOKIE, '', -1, 'Lax', isSecureContext(), hintDomain());
};
